module.exports = __webpack_public_path__ + "img/mutil.781fb38e.png";